// Copyright Epic Games, Inc. All Rights Reserved.

import { StatusCodeError } from "../errors/StatusCodeError";

export const clientFetch = (
  input: RequestInfo,
  init?: RequestInit
): Promise<Response> =>
  fetch(input, init).then((response) => {
    // Check that it is not success code.
    if (!String(response.status).startsWith("2")) {
      throw new StatusCodeError(
        response.status,
        `HTTP Request failed with ${response.status}`
      );
    }

    return response;
  });
